import { render, staticRenderFns } from "./ConfirmRestoreDialog.vue?vue&type=template&id=707c1574"
import script from "./ConfirmRestoreDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmRestoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports